import {fetch} from '@/utils/fetch';

export function getReceiptList(
    {
        page, size, direction, sort, equipmentCode, isInCompany
    },
) {
    return fetch({
        url: `${ process.env.VUE_APP_BASE_URL }/get-receipt-list`,
        method: 'post',
        params: {
            page, size, direction, sort, equipmentCode, isInCompany
        },
    });
}

export function getAddress({ key, location }) {
    return fetch({
        url: 'https://restapi.amap.com/v3/geocode/regeo',
        method: 'get',
        params: {
            key,
            location
        }
    })
}
